import React, { useEffect } from 'react';
//import { Link } from 'react-router-dom';
import useHelpStore from '../store/cmsStore/helpStore';
import Seo from '../components/Seo';
import { Link, useLocation } from 'react-router-dom';


const Help: React.FC = () => {
  const {sections, fetchHelpContent } = useHelpStore();
  const location = useLocation();
  useEffect(() => {

    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }else{
      window.scrollTo(0, 0);
    }
  }, [location]);

  useEffect(() => {

    fetchHelpContent();
  }, [fetchHelpContent]);

  return (
    <>
        <Seo
          title="Answers, Support & Guidance for You | SLAMMMM Help Center"
          description="Have a question about SLAMMMM? Our Help Center covers everything from creating your profile to matching, safety, privacy, and billing. All in one place."
        />
     {sections.help_section && (
      <section className="py-100 breadcrumb_section bg-light border-bottom">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="section_title text-center">

                        <h1 className="mb-0" dangerouslySetInnerHTML={{ __html: sections.help_section.payload.field_1.value }}></h1>

                    </div>
                </div>
            </div>
        </div>
    </section>
        )}
    <section className="py-60 relationship_coaching_section" id="relationship_coaching">
        <div className="container">
            <div className="border-top ">
                <div className="section_title py-60">
                {sections.help_section && ( 
                    <h2 className="mb-0">{sections.help_section.payload.field_3.value}</h2>
                )}
                </div>
                <div className="row gx-lg-5">
                    <div className="col-lg-5">
                        <div className="mb-4">
                        {sections.help_section && ( 
                            <img alt="" className="img-fluid" src={sections.help_section.payload.field_4.value} />
                          )}
                        </div>
                    </div>
                    {sections.help_section && ( 
                    <div className="col-lg-7" dangerouslySetInnerHTML={{ __html: sections.help_section.payload.field_5.value }}></div>
                  )}
                  {sections.help_section && ( 
                    <div className="col-lg-12">
                      <div className="" dangerouslySetInnerHTML={{ __html: sections.help_section.payload.field_6.value }}></div>
                      <Link to={sections.help_section.payload.field_7.link || '#'}><button className="btn btn-primary">{sections.help_section.payload.field_7.value}</button></Link>
                    </div>
                      )}
                </div>
            </div>
        </div>
    </section>
    </>
  );
};

export default Help;
